export default "__VITE_ASSET__CJLQxEOX__"